import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SectionHeading from "@/components/base/SectionHeading";

const STEPS = [
  {
    icon: "ri-user-add-line",
    titleKey: "helpCenter.step1Title",
    descKey: "helpCenter.step1Desc",
    ctaKey: "helpCenter.step1Cta",
    to: "/auth",
  },
  {
    icon: "ri-file-add-line",
    titleKey: "helpCenter.step2Title",
    descKey: "helpCenter.step2Desc",
    ctaKey: "helpCenter.step2Cta",
    to: "/apply",
  },
  {
    icon: "ri-time-line",
    titleKey: "helpCenter.step3Title",
    descKey: "helpCenter.step3Desc",
    ctaKey: "helpCenter.step3Cta",
    to: "/apply",
  },
  {
    icon: "ri-key-2-line",
    titleKey: "helpCenter.step4Title",
    descKey: "helpCenter.step4Desc",
    ctaKey: "helpCenter.step4Cta",
    to: "/licenses",
  },
];

export default function QuickStart() {
  const { t } = useTranslation();

  return (
    <section id="quickstart" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-5xl px-4 py-14 md:px-6 md:py-16">
        <SectionHeading
          align="center"
          eyebrow={t("helpCenter.quickEyebrow")}
          title={t("helpCenter.quickTitle")}
          description={t("helpCenter.quickDesc")}
        />

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, index) => (
            <div
              key={step.titleKey}
              className="lh-fade-up flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${step.icon} text-xl`} />
                </span>
                <span className="font-mono text-xs text-foreground-400">
                  {t("helpCenter.quickStepTag", { num: index + 1 })}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {t(step.titleKey)}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{t(step.descKey)}</p>
              <Link
                to={step.to}
                className="mt-4 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
              >
                {t(step.ctaKey)}
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}